import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Creatable } from "react-select";
import { reduceById } from "redux-store";
import { BackButton } from "ui/button/back";
import { BasicLoader } from "ui/loader";
import { Notification } from "ui/notification";
import { getErrorMessage, getFormErrors } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class DeviceRegistrationPage extends React.PureComponent {
  static get propTypes() {
    return {
      addErrorMessage: PropTypes.func.isRequired,
      addNewDevice: PropTypes.func.isRequired,
      deviceTags: PropTypes.array.isRequired,
      getVistarVenues: PropTypes.func.isRequired,
      networks: PropTypes.object.isRequired,
      vistarAccountIds: PropTypes.array,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      formErrors: {},
      isAgent: false,
      networkVenues: [],
      selectedNetwork: null,
      selectedTags: [],
      selectedVenue: null,
      success: false,
      systemErrors: {},
      venueLoading: false,
      vistarVenues: {},
    };

    this.deviceName = null;
    this.registrationCode = null;

    this._onNetworkSelect = this._onNetworkSelect.bind(this);
    this._onNetworkVenueSelect = this._onNetworkVenueSelect.bind(this);
    this._onTagSelect = this._onTagSelect.bind(this);
    this._toggleIsAgent = this._toggleIsAgent.bind(this);
    this._submit = this._submit.bind(this);
  }

  _submit() {
    const { selectedTags, selectedNetwork, isAgent } = this.state;
    const { addNewDevice } = this.props;

    const location = this._getLocation();
    const partnerVenueId = this._getPartnerVenueId();
    const tags = selectedTags.map((t) => t.label);

    const deviceName = get(this.deviceName, "value", null);
    const networkId = get(selectedNetwork, "value", null);
    const registrationCode = get(this.registrationCode, "value", null);

    const serviceArgs = {
      deviceName,
      location,
      isAgent,
      networkId,
      partnerVenueId,
      registrationCode,
      tags,
    };

    return addNewDevice(serviceArgs)
      .then(() => {
        this.setState({ success: true, ...getFormErrors() });
      })
      .catch((resp) => {
        this.setState({ success: false, ...getFormErrors(resp) });
      });
  }

  /*
   * Precondition: this is only called when selected
   * network has network.vistar_network_id.
   */
  _fetchVenues() {
    const { addErrorMessage, getVistarVenues } = this.props;
    const { selectedNetwork } = this.state;
    const networkId = selectedNetwork.value;

    return getVistarVenues(networkId)
      .then((resp) => {
        const { data } = resp.data;
        const vistarVenues = reduceById({}, data);
        const networkVenues = this.getNetworkVenueOpts(data);

        this.setState({ networkVenues, vistarVenues });
      })
      .catch((resp) => {
        addErrorMessage(getErrorMessage(resp));
      })
      .finally(() => {
        this.setState({ venueLoading: false });
      });
  }

  _getSelectedVenue() {
    const { selectedVenue, vistarVenues } = this.state;

    return selectedVenue ? vistarVenues[selectedVenue.value] : null;
  }

  _getPartnerVenueId() {
    const selectedVenue = this._getSelectedVenue();

    return selectedVenue ? selectedVenue.partner_venue_id : null;
  }

  _getLocation() {
    const selectedVenue = this._getSelectedVenue();
    if (selectedVenue) {
      const lat = selectedVenue.latitude;
      const long = selectedVenue.longitude;

      return `${lat},${long}`;
    }

    return null;
  }

  _toggleIsAgent(e) {
    this.setState({ isAgent: e.target.value === "agent" });
  }

  _onTagSelect(tagOpts) {
    this.setState({ selectedTags: tagOpts });
  }

  _onNetworkSelect(networkOpt) {
    this.setState({
      networkVenues: [],
      selectedNetwork: networkOpt,
      vistarVenues: {},
    });

    if (!networkOpt) {
      return;
    }

    const network = this.props.networks[networkOpt.value];
    if (
      network &&
      network.vistar_network_id &&
      !isEmpty(this.props.vistarAccountIds)
    ) {
      this.setState({ venueLoading: true }, this._fetchVenues);
    }
  }

  _onNetworkVenueSelect(venueOpt) {
    this.setState({ selectedVenue: venueOpt });
  }

  _getNetworkOpts() {
    const { networks } = this.props;

    return Object.values(networks).map((network) => {
      return {
        value: network.id,
        label: network.name,
      };
    });
  }

  getNetworkVenueOpts(venues) {
    return venues.map((venue) => {
      return {
        value: venue.id,
        label: `${venue.name} (${venue.partner_venue_id})`,
      };
    });
  }

  _renderVistarVenues() {
    const { networkVenues, selectedNetwork, selectedVenue, venueLoading } =
      this.state;

    if (!selectedNetwork) {
      return null;
    }

    if (venueLoading) {
      return (
        <Row>
          <Col xs={12}>
            <BasicLoader>Fetching Venues...</BasicLoader>
          </Col>
        </Row>
      );
    }

    if (networkVenues.length === 0) {
      return null;
    }

    return (
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Vistar Venues</Form.Label>
            <Select
              name="networkVenues"
              onChange={this._onNetworkVenueSelect}
              options={networkVenues}
              value={selectedVenue}
            />
            <Form.Text>
              Please choose related Vistar Trafficking Venue from the list.
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    );
  }

  render() {
    const { deviceTags } = this.props;
    const {
      formErrors,
      isAgent,
      selectedNetwork,
      selectedTags,
      success,
      venueLoading,
    } = this.state;

    const successMessage = success ? "Your device is registered now." : null;

    return (
      <Page title="Register Device">
        <Box noHeader={true}>
          <Row>
            <Col xs={6}>
              <Notification
                success={successMessage}
                successChildren={<Link to="/devices">Device List</Link>}
                error={formErrors.message}
              />
              <Row>
                <Col xs={12}>
                  <Form.Group controlId="config">
                    <Form.Label>
                      <strong>Choose from the two options below</strong>
                    </Form.Label>
                    <br />
                    <Form.Check
                      type="radio"
                      inline
                      label="Register Cortex Player"
                      checked={!isAgent}
                      name="isAgent"
                      onChange={this._toggleIsAgent}
                      value="player"
                    />
                    <Form.Check
                      type="radio"
                      inline
                      label="Register Agent"
                      checked={isAgent}
                      name="isAgent"
                      onChange={this._toggleIsAgent}
                      value="agent"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Group
                    controlId="registrationCode"
                  >
                    <Form.Label>Registration code</Form.Label>
                    <Form.Control
                      type="text"
                      ref={(elem) => {
                        if (elem) {
                          this.registrationCode = elem;
                        }
                      }}
                      name="code"
                      placeholder="Registration code"
                      required
                      isInvalid={formErrors.code ? "error" : null}
                    />
                    <Form.Text>
                      {`Required. Enter the 6 letter registration code
                      ${isAgent ? "stored" : "displayed"} on your device or
                      your device MAC address.`}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Group
                    controlId="network"
                  >
                    <Form.Label>Network</Form.Label>
                    <Select
                      name="networks"
                      onChange={this._onNetworkSelect}
                      options={this._getNetworkOpts()}
                      value={selectedNetwork}
                      required
                      className={formErrors.networkId ? "is-invalid" : ""}
                    />
                    <Form.Text>
                      Required. Please select the device network.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              {this._renderVistarVenues()}
              <Row>
                <Col xs={12}>
                  <Form.Group
                    controlId="deviceName"
                  >
                    <Form.Label>Device name</Form.Label>
                    <Form.Control
                      type="text"
                      ref={(elem) => {
                        if (elem) {
                          this.deviceName = elem;
                        }
                      }}
                      name="name"
                      placeholder="Device name"
                      required
                      isInvalid={formErrors.name ? "error" : null}
                    />
                    <Form.Text>
                      Required. Name your device for future reference.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>Device Tags</Form.Label>
                    <Creatable
                      name="device-tags"
                      promptTextCreator={(tag) => {
                        return `Create tag "${tag}"`;
                      }}
                      onChange={this._onTagSelect}
                      options={deviceTags}
                      value={selectedTags}
                      isMulti
                      className={formErrors.tags ? "is-invalid" : ""}
                    />
                    <Form.Text>
                      Optional. Type one tag at a time and hit Enter. Tags are
                      case-insensitive and must start with alphanumeric
                      characters. Tags can only contain alphanumeric characters,
                      &quot;-&quot;, &quot;_&quot; or a space.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <BackButton />
                  <Button
                    variant="primary"
                    name="submit-button"
                    onClick={this._submit}
                    disabled={venueLoading}
                  >
                    Register
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Box>
      </Page>
    );
  }
}

export { DeviceRegistrationPage };
